"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=DetailsFooter.types.js.map